import { Button, Tag, Typography } from "antd";
import styles from "./subStatusMenuItem.module.scss";
import { OutgoingTransitionIcon } from "../../../outgoingTransitionIcon/outgoingTransitionIcon";
import { IncomingTransitionIcon } from "../../../incomingTransitionIcon/incomingTransitionIcon";

const { Text } = Typography;

export const SubStatusMenuItem = ({
  isSubStatusDisabled,
  incomingTransitionsCount,
  outgoingTransitionsCount,
  children,
  onClick,
  isSelected,
}) => {
  return (
    <Button
      type="text"
      className={`${styles.subStatus} ${isSelected ? styles.selected : ""} ${
        isSubStatusDisabled ? styles.disabled : ""
      }`}
      onClick={onClick}
    >
      <span>{children}</span>
      {isSubStatusDisabled ? (
        <Text style={{ color: "inherit" }}>Disabled</Text>
      ) : (
        <div className={styles.transitionsContainer}>
          <Tag
            icon={<IncomingTransitionIcon fontSize={8} />}
            className={styles.transitionCount}
          >
            {incomingTransitionsCount}
          </Tag>
          <Tag
            icon={<OutgoingTransitionIcon fontSize={8} />}
            className={styles.transitionCount}
          >
            {outgoingTransitionsCount}
          </Tag>
        </div>
      )}
    </Button>
  );
};
